"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListCell = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _cell = require("@cbhq/cds-common/tokens/cell");
var _Box = require("../layout/Box");
var _VStack = require("../layout/VStack");
var _TextBody = require("../typography/TextBody");
var _TextHeadline = require("../typography/TextHeadline");
var _Cell = require("./Cell");
var _CellAccessory = require("./CellAccessory");
var _CellDetail = require("./CellDetail");
const _excluded = ["accessory", "action", "compact", "title", "description", "detail", "disabled", "media", "multiline", "selected", "subdetail", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ListCell = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function ListCell(_ref, ref) {
  let accessory = _ref.accessory,
    action = _ref.action,
    compact = _ref.compact,
    title = _ref.title,
    description = _ref.description,
    detail = _ref.detail,
    disabled = _ref.disabled,
    media = _ref.media,
    multiline = _ref.multiline,
    selected = _ref.selected,
    subdetail = _ref.subdetail,
    variant = _ref.variant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const minHeight = (0, _useScaleConditional.useScaleConditional)(compact ? _cell.compactListHeight : _cell.listHeight);
  const accessoryType = selected ? 'selected' : accessory;
  let end;
  if (action) {
    end = /*#__PURE__*/_react.default.createElement(_Box.Box, {
      justifyContent: "flex-end"
    }, action);
  } else if (detail || subdetail) {
    end = /*#__PURE__*/_react.default.createElement(_CellDetail.CellDetail, {
      detail: detail,
      subdetail: subdetail,
      variant: variant
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Cell.Cell, _extends({}, props, {
    ref: ref,
    accessory: accessoryType && /*#__PURE__*/_react.default.createElement(_CellAccessory.CellAccessory, {
      type: accessoryType
    }),
    detail: end,
    disabled: disabled,
    media: media,
    minHeight: minHeight,
    selected: selected
  }), /*#__PURE__*/_react.default.createElement(_VStack.VStack, null, !!title && /*#__PURE__*/_react.default.createElement(_TextHeadline.TextHeadline, {
    as: "div",
    overflow: "truncate"
  }, title), !!description && /*#__PURE__*/_react.default.createElement(_TextBody.TextBody, {
    as: "div",
    className: multiline ? _Cell.overflowClassName : undefined,
    color: "foregroundMuted",
    overflow: multiline ? undefined : 'truncate'
  }, description)));
}));
exports.ListCell = ListCell;